import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import _ from 'lodash'

import { openReportById } from '../../../../scenes/Report/actions'
import { openLinkagesById } from '../../../../scenes/Linkages/actions'
import { setupDistraintsById } from '../../../../scenes/Distraints/actions'

function mapStateToProps(state, hocProps) {
    const id = hocProps?.id

    return {
        shouldAddToFavourites: !state
            .getIn(['ui', 'entityStack', 'favourites', 'entities'])
            .find((favourite) => _.toString(favourite.get('entId')) === _.toString(id)),
    }
}

export function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            openReportById,
            openLinkagesById,
            setupDistraintsById,
        },
        dispatch
    )
}

export default function (InnerComponent) {
    @connect(mapStateToProps, mapDispatchToProps)
    class HocConnect extends Component {
        render() {
            return <InnerComponent {...this.props} />
        }
    }
    return HocConnect
}
